import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArrayService {
  public convertFromCSV(value: string | null | undefined): string[] {
    if (!value) {
      return [];
    }
    return value
      .split(',')
      .map((x) => x.trim())
      .filter((x) => x.length > 0);
  }
}
